import React from 'react';

const BudgetDrawerContext = React.createContext({ forms: [] });

export { BudgetDrawerContext };
